import { PLPQueryData, usePLPQuery } from 'client/api/plp-results';
import { rootId } from 'common/config';
import { useCallback, useEffect } from 'react';

export function useBeaconScript() {
  const { data } = usePLPQuery(useCallback((d: PLPQueryData) => d.meta, []));

  useEffect(() => {
    if (!data) return;

    const rootElement = document.querySelector(`#${rootId}`);
    if (rootElement === null) return;

    const script = document.createElement('script');
    script.id = 'cnstrc-data';
    script.type = 'application/json';
    script.innerHTML = JSON.stringify(data);
    rootElement.appendChild(script);

    // eslint-disable-next-line consistent-return
    return () => {
      rootElement.removeChild(script);
    };
  }, [data]);
}
